import { ApiService } from './api.service';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfirmaEmailService {

  constructor(private api: ApiService) {}

  getUserData(id, code) {
    const endpoint = 'Account/'+ id +'/confirm?code='+encodeURIComponent(code);
    const route = environment.API_URL + endpoint;
    return this.api.get$(route);
  }
}
